import { PROOF_DOMAIN } from "../types";

export const VK_HASH_CONFIG = {
  [PROOF_DOMAIN.RETAIL_BRIDGE_ORDER]: '0x0ca4f42da1fbc3e0f0b6b715f2b5458e41ff6c91f0a0c4b035cd64243c2661d6',
}
